import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export interface UserItem {
  id: string;
  name: string;
  email: string;
  username: string;
  roles: string[];
  enabled: boolean;
  forcePasswordChange: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UsersListResponse {
  items: UserItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface UsersListParams {
  page?: number;
  pageSize?: number;
  enabled?: boolean;
  role?: string;
  q?: string;
}

export interface CreateUserPayload {
  name: string;
  email: string;
  username: string;
  password: string;
  roles: string[];
  enabled: boolean;
  forcePasswordChange: boolean;
}

export interface UpdateUserPayload {
  name: string;
  email: string;
  username: string;
  roles: string[];
  enabled: boolean;
}

export interface PasswordResetResponse {
  tempPassword: string;
  notified: boolean;
}

export const UsersService = {
  // --- Perfil propio (auth/me) ---
  getUser: () => HTTP.get<any>(`${API_ENDPOINT.CORE}auth/me`),

  editUser: (data: { name: string; email: string; username: string }) =>
    HTTP.put<any, any>(`${API_ENDPOINT.CORE}auth/me`, data),

  changePassword: (data: { currentPassword: string; newPassword: string }) =>
    HTTP.put<any, any>(`${API_ENDPOINT.CORE}auth/me/password`, data),

  // --- Administración de usuarios (backoffice) ---
  listUsers: (params: UsersListParams = {}) =>
    HTTP.get<UsersListResponse, UsersListResponse>(`${API_ENDPOINT.CORE}users`, { params }),

  getUserById: (id: string) => HTTP.get<UserItem, UserItem>(`${API_ENDPOINT.CORE}users/${id}`),

  createUser: (data: CreateUserPayload) =>
    HTTP.post<UserItem, UserItem>(`${API_ENDPOINT.CORE}users`, data),

  updateUser: (id: string, data: UpdateUserPayload) =>
    HTTP.put<UserItem, UserItem>(`${API_ENDPOINT.CORE}users/${id}`, data),

  deleteUser: (id: string) => HTTP.delete<any, any>(`${API_ENDPOINT.CORE}users/${id}`),

  resetPassword: (id: string, notify = false) =>
    HTTP.post<PasswordResetResponse, PasswordResetResponse>(
      `${API_ENDPOINT.CORE}users/${id}/password-reset`,
      { notify }
    )
};
